import script from "./product-diary-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./product-diary-tab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__